import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import remarkTemplateListAPI from '../apis/remarkTemplateListAPI'
import alertMessage from '../utils/alertMessage'

export default class RemarkTemplateListStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0

  /*SearchResult start*/
  @observable searchItem = {
    'isPowerUser' : false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable remarkList = []
  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.remarkList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await remarkTemplateListAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.remarkList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  /*SearchResult end*/
  @action
  onChangeRemark(value) {
    this.remarkList = value
    this.itemCount = 0
  }

  /*get permission*/
  @observable detailsObj = null
  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await remarkTemplateListAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data, code} = response.data
        if (code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*add permission*/
  @observable isFetchingAdd = false
  @action
  async onAddJobAction(params, title) {
    this.isFetchingAdd = true
    try {
      const response = await remarkTemplateListAPI.addAction(params)
      runInAction(() => {
        this.isFetchingAdd = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingAdd = false
      })
    }
  }

  /*delete permission*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await remarkTemplateListAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'isPowerUser' : this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }
}
